import { useSelector } from 'react-redux';
import { useSuspenseQuery } from '@tanstack/react-query';
import { API } from 'api';

import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

import { apiName, apiBasePath } from 'assets';
import { getMainAccountId } from 'store/account';
import { ConsultAgent } from 'types/Consult';

export async function getConsultAgents(mainAccountId: string) {
  const response = await API.get(
    apiName,
    `${apiBasePath}/consult-agents`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.CONSULTS,
        domain: DOMAINS.CONSULTS,
        importance: IMPORTANCE.MEDIUM,
      },
      context: {
        mainAccountId,
      },
    },
  );
  return response;
}

const useConsultAgents = () => {
  const mainAccountId = useSelector(getMainAccountId);

  const consultAgentsListQuery = useSuspenseQuery<ConsultAgent[]>({
    queryKey: [apiName, `consultAgentsList`, mainAccountId],
    queryFn: () => (mainAccountId ? getConsultAgents(mainAccountId) : []),
  });

  return consultAgentsListQuery;
};

export default useConsultAgents;
